import React, { FC } from 'react'

const FolderIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M21.3819 20H3.6466C3.3079 20 3 19.7041 3 19.3095V5.53191C3 5.17021 3.27711 4.84139 3.6466 4.84139H12.4834C12.7298 4.84139 12.9453 4.70986 13.0377 4.47969L13.5611 3.3617C13.6843 3.13153 13.8998 3 14.1153 3H21.3511C21.6898 3 21.9977 3.29594 21.9977 3.69052V19.3095C22.0285 19.6712 21.7513 20 21.3819 20Z'
        fill='#62C5E8'
      />
      <path
        d='M21.1054 20H3.64662C3.30791 20 3 19.7215 3 19.3501V6.38298C3 6.04255 3.27712 5.73308 3.64662 5.73308H12.4838C12.7301 5.73308 12.9456 5.60928 13.038 5.39265L13.5615 4.34043C13.6846 4.12379 13.9002 4 14.1157 4H21.3517C21.6904 4 21.9983 4.27853 21.9983 4.6499V19.0716C22.0291 19.5667 21.6288 20 21.1054 20Z'
        fill='#49A8C3'
      />
      <path
        d='M2 7.93301V19.067C2 19.5957 2.40625 20 2.9375 20H21.0625C21.5938 20 22 19.5957 22 19.067V9.42584C22 8.89713 21.5938 8.49282 21.0625 8.49282H11.9375C11.6875 8.49282 11.4375 8.39952 11.2812 8.21292L10.3438 7.2799C10.1562 7.0933 9.9375 7 9.6875 7H2.9375C2.40625 7 2 7.43541 2 7.93301Z'
        fill='#70CEEA'
      />
      <path
        d='M2 7.93301V19.067C2 19.5957 2.40625 20 2.9375 20H21.0625C21.5938 20 22 19.5957 22 19.067V9.42584C22 8.89713 21.5938 8.49282 21.0625 8.49282H11.9375C11.6875 8.49282 11.4375 8.39952 11.2812 8.21292L10.3438 7.2799C10.1562 7.0933 9.9375 7 9.6875 7H2.9375C2.40625 7 2 7.43541 2 7.93301Z'
        fill='#62C5E8'
      />
    </svg>
  )
}

export default FolderIcon
